<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import ppMatrixAPI from "@/services/standards/promotionPrevention/ppMatrixAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";

const MONTHS = [
  { n: 1, label: "Ene" }, { n: 2, label: "Feb" }, { n: 3, label: "Mar" }, { n: 4, label: "Abr" },
  { n: 5, label: "May" }, { n: 6, label: "Jun" }, { n: 7, label: "Jul" }, { n: 8, label: "Ago" },
  { n: 9, label: "Sep" }, { n: 10, label: "Oct" }, { n: 11, label: "Nov" }, { n: 12, label: "Dic" },
];

function blankRow() {
  return {
    id_actividad: "", nivel_riesgo: null, peligro: "", actividad: "", responsable: "",
    planned_months: [], executed_months: [], codigo_acta: "", num_asistentes: null,
    evidencia_file: null, estado: "Programada", _uploading: false,
  };
}

export default {
  page: { title: "Matriz y Cronograma de P&P" },
  components: { Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "7.1.1 Matriz y Cronograma de Promoción y Prevención",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "7.1.1 Promoción y Prevención", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      matrixId: this.$route.params.matrix || null,
      catalog: { niveles_riesgo: [], estados: [] },
      monthOptions: MONTHS.map((m) => ({ value: m.n, text: m.label })),
      form: { version: "1.0", anio: new Date().getFullYear(), fecha: new Date().toISOString().substring(0, 10), observacion: null },
      rows: [blankRow()],
      workflowStatus: "draft", signedAt: null, submitting: false, loading: true,
    };
  },
  computed: {
    isSigned() { return this.workflowStatus === "signed"; },
    matrixApi() {
      return {
        pdfUrl: (id) => ppMatrixAPI.pdfUrl(id),
        sign: (id, payload) => ppMatrixAPI.sign(id, payload),
      };
    },
    dashboard() {
      let prog = 0, ejec = 0;
      this.rows.forEach((r) => { prog += (r.planned_months || []).length; ejec += (r.executed_months || []).length; });
      return { total: this.rows.length, programadas: prog, ejecutadas: ejec, pct: prog ? Math.round((ejec / prog) * 100) : 0 };
    },
  },
  methods: {
    goBack() { this.$router.go(-1); },
    addRow() { if (!this.isSigned) this.rows.push(blankRow()); },
    removeRow(idx) {
      if (this.isSigned) return;
      this.rows.splice(idx, 1);
      if (!this.rows.length) this.rows.push(blankRow());
    },
    fileName(url) { return String(url).split("/").pop(); },
    load() {
      if (!this.matrixId) { this.loading = false; return; }
      ppMatrixAPI.get(this.matrixId)
        .then((r) => {
          if (!r) { this.loading = false; return; }
          this.form.version = r.version || "1.0";
          this.form.anio = r.anio || this.form.anio;
          this.form.fecha = r.fecha ? String(r.fecha).substring(0, 10) : this.form.fecha;
          this.form.observacion = r.observacion || null;
          this.rows = (r.rows && r.rows.length)
            ? r.rows.map((x) => ({
                ...blankRow(), ...x,
                planned_months: Array.isArray(x.planned_months) ? x.planned_months.map(Number) : [],
                executed_months: Array.isArray(x.executed_months) ? x.executed_months.map(Number) : [],
              }))
            : [blankRow()];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { companies_id: this.companyID, ...this.form, rows: this.rows };
      const req = this.matrixId ? ppMatrixAPI.update(this.matrixId, payload) : ppMatrixAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 57, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Matriz guardada.", icon: "success", timer: 1600, showConfirmButton: false });
          this.submitting = false;
          if (!this.matrixId && res && res.id) {
            this.matrixId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/pp-matriz/${res.id}` });
            this.load();
          }
        })
        .catch((e) => { console.log(e); this.submitting = false; Swal.fire("Error", "No se pudo guardar la matriz", "error"); });
    },
    async onEvidenceFile(row, event) {
      if (this.isSigned) return;
      const file = event.target.files[0];
      if (!file) return;
      row._uploading = true;
      try {
        const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
        const path = `${base}/${this.nit}/7.1.1/pp-evidencias/${this.matrixId || "nuevo"}/${Date.now()}_${file.name}`;
        const ok = await uploadDocument(path, file);
        if (!ok) throw new Error("upload");
        row.evidencia_file = `${process.env.VUE_APP_BUCKET}/${path}`;
        Swal.fire({ title: "Evidencia cargada", icon: "success", timer: 1200, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo cargar la evidencia", "error");
      } finally {
        row._uploading = false;
        if (event.target) event.target.value = null;
      }
    },
    removeEvidence(row) { if (!this.isSigned) row.evidencia_file = null; },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    ppMatrixAPI.catalog().then((c) => { if (c) this.catalog = { ...this.catalog, ...c }; });
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Planifica el cronograma anual de actividades de promoción y prevención. Por cada actividad indica el
                nivel de riesgo, el peligro/hallazgo, el responsable, marca los <b>meses Planeados (P) y Ejecutados
                (E)</b>, y registra el código de acta, N° de asistentes y evidencia. La plataforma calcula el % de
                cumplimiento del cronograma y la ejecución por nivel de riesgo. Cada guardado es una versión y puede
                firmarse.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta versión ya fue firmada; los datos quedan bloqueados. Crea una "Nueva versión" desde el hub.
            </div>

            <form @submit.prevent="save">
              <div class="form-row">
                <b-form-group class="col-md-2 px-2" label="Versión"><b-form-input type="text" v-model="form.version" :disabled="isSigned" /></b-form-group>
                <b-form-group class="col-md-2 px-2" label="Año"><b-form-input type="number" v-model.number="form.anio" :disabled="isSigned" /></b-form-group>
                <b-form-group class="col-md-3 px-2" label="Fecha"><b-form-input type="date" v-model="form.fecha" :disabled="isSigned" required /></b-form-group>
                <b-form-group class="col-md-5 px-2" label="Observación"><b-form-input type="text" v-model="form.observacion" :disabled="isSigned" /></b-form-group>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-2">
                <h5 class="mb-0">Actividades y cronograma</h5>
                <span class="small">
                  <span class="badge badge-primary">Actividades: {{ dashboard.total }}</span>
                  <span class="badge badge-info">Programadas (mes): {{ dashboard.programadas }}</span>
                  <span class="badge badge-success">Ejecutadas (mes): {{ dashboard.ejecutadas }}</span>
                  <span class="badge badge-warning">% Cumplimiento: {{ dashboard.pct }}%</span>
                </span>
              </div>

              <div v-for="(row, idx) in rows" :key="idx" class="border rounded p-2 mb-3">
                <div class="d-flex justify-content-between">
                  <strong class="small text-primary">Actividad #{{ idx + 1 }}</strong>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0" :disabled="isSigned" @click="removeRow(idx)"><i class="mdi mdi-trash-can"></i></button>
                </div>
                <div class="form-row">
                  <b-form-group class="col-md-2 px-2" label="ID actividad"><b-form-input v-model="row.id_actividad" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="Nivel de riesgo">
                    <b-form-select v-model="row.nivel_riesgo" :disabled="isSigned" size="sm">
                      <b-form-select-option :value="null">—</b-form-select-option>
                      <b-form-select-option v-for="n in catalog.niveles_riesgo" :key="n" :value="n">{{ n }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Peligro / hallazgo"><b-form-input v-model="row.peligro" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Responsable"><b-form-input v-model="row.responsable" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-12 px-2" label="Programa / actividad de P&P"><b-form-input v-model="row.actividad" :disabled="isSigned" size="sm" /></b-form-group>
                </div>
                <div class="bg-light rounded p-2">
                  <p class="text-muted small mb-1">Marca los meses Planeados (P):</p>
                  <b-form-checkbox-group v-model="row.planned_months" :options="monthOptions" :disabled="isSigned" class="small" />
                  <p class="text-muted small mb-1 mt-2">Marca los meses Ejecutados (E):</p>
                  <b-form-checkbox-group v-model="row.executed_months" :options="monthOptions" :disabled="isSigned" class="small" />
                </div>
                <div class="form-row align-items-end mt-1">
                  <b-form-group class="col-md-3 px-2" label="Código acta / registro"><b-form-input v-model="row.codigo_acta" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-2 px-2" label="N° asistentes"><b-form-input type="number" v-model.number="row.num_asistentes" :disabled="isSigned" size="sm" /></b-form-group>
                  <b-form-group class="col-md-3 px-2" label="Estado">
                    <b-form-select v-model="row.estado" :disabled="isSigned" size="sm">
                      <b-form-select-option v-for="e in catalog.estados" :key="e" :value="e">{{ e }}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group class="col-md-4 px-2" label="Evidencia">
                    <b-form-file :disabled="isSigned || row._uploading" browse-text="Buscar" :placeholder="row._uploading ? 'Subiendo...' : 'Selecciona...'" @change="onEvidenceFile(row, $event)" size="sm" />
                  </b-form-group>
                  <div class="col-12 px-2 small" v-if="row.evidencia_file">
                    <a :href="row.evidencia_file" target="_blank"><i class="mdi mdi-paperclip"></i> {{ fileName(row.evidencia_file) }}</a>
                    <button v-if="!isSigned" type="button" class="btn btn-outline-danger btn-sm py-0 ml-1" @click="removeEvidence(row)"><i class="mdi mdi-close"></i></button>
                  </div>
                </div>
              </div>

              <button type="button" class="btn btn-outline-primary btn-sm mb-3" :disabled="isSigned" @click="addRow"><i class="mdi mdi-plus"></i> Agregar actividad</button>

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && matrixId">
        <h6 class="text-muted small mb-1">Matriz y Cronograma de P&amp;P</h6>
        <DocumentActions
          :document-id="Number(matrixId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="matrixApi"
          document-title="Matriz y Cronograma de Promoción y Prevención"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
    </div>
  </Layout>
</template>
